import { Flex, Text } from '@chatsdet/ui';
type PresetButtonProps = {
  label: string;
  value: string;
  onClick: (value: string) => void;
  disabled: boolean;
};

function PresetButton({ label, value, onClick, disabled }: PresetButtonProps) {
  return (
    <button
      type="button"
      onClick={() => onClick(value)}
      className="text-xs px-2 py-0.5 rounded border border-border hover:bg-muted transition-colors"
      disabled={disabled}
    >
      {label}
    </button>
  );
}

const CRON_PRESETS = [
  { label: 'Weekdays 8am', value: '0 8 * * 1-5' },
  { label: 'Every hour', value: '0 * * * *' },
  { label: 'Every 6 hours', value: '0 */6 * * *' },
  { label: 'Daily midnight', value: '0 0 * * *' },
  { label: 'Monday 9am', value: '0 9 * * 1' },
  { label: 'Monthly (1st)', value: '0 0 1 * *' },
];

const TIMEZONE_PRESETS = [
  { label: 'UTC', value: 'UTC' },
  { label: 'London', value: 'Europe/London' },
  { label: 'Eastern', value: 'America/New_York' },
  { label: 'Central', value: 'America/Chicago' },
  { label: 'Mountain', value: 'America/Denver' },
  { label: 'Pacific', value: 'America/Los_Angeles' },
];

export function CronPatternPresets({
  onSelect,
  disabled,
}: {
  onSelect: (pattern: string) => void;
  disabled: boolean;
}) {
  return (
    <Flex gap="xs" wrap="wrap" className="mt-2">
      <Text size="xs" className="text-muted-foreground mr-2">
        Quick presets:
      </Text>
      {CRON_PRESETS.map((preset) => (
        <PresetButton
          key={preset.value}
          label={preset.label}
          value={preset.value}
          onClick={onSelect}
          disabled={disabled}
        />
      ))}
    </Flex>
  );
}

export function TimezonePresets({
  onSelect,
  disabled,
}: {
  onSelect: (tz: string) => void;
  disabled: boolean;
}) {
  return (
    <Flex gap="xs" wrap="wrap">
      {TIMEZONE_PRESETS.map((preset) => (
        <PresetButton
          key={preset.value}
          label={preset.label}
          value={preset.value}
          onClick={onSelect}
          disabled={disabled}
        />
      ))}
    </Flex>
  );
}
